import { gql } from "urql";

export const PRODUCT_GEN_SKU = gql`
  mutation productGenSku($productType: String!) {
    productGenSku(productType: $productType) {
      data
    }
  }
`;
